import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { IIdentificationDocumentType } from '../../shared/models/catalog/identificaction-document-type';

export const identificationTypeApi = createApi({
  reducerPath: 'identificationTypeApi',
  baseQuery,
  endpoints: (builder) => ({
    identificationTypes: builder.query<IPagedResult<IIdentificationDocumentType>, string>({
      query: (params) => ({
        url: `/api/identificationdocumenttypes?${params}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useIdentificationTypesQuery } = identificationTypeApi;
